/** Rounds a distance per spec §8.4: to 10 km from 100 km up, to 1 km below. */
export function roundDistanceKm(km) {
    const step = km >= 100 ? 10 : 1;
    return Math.round(km / step) * step;
}
/** Formats a (already rounded) distance in km with a locale thousands separator. */
export function formatDistanceKm(km, lang) {
    const rounded = roundDistanceKm(km);
    const locale = lang === "de" ? "de-DE" : "en-US";
    return new Intl.NumberFormat(locale).format(rounded);
}
//# sourceMappingURL=distance.js.map